export default {
  watch: {
    show(show) {
      show && this.onShow()
    },
  },
  methods: {
    onShow() {
      this.itemData = this.$options.data().itemData;
    },
  },
}
